import React from "react";

function Mission() {
  return (
    <>
      <div className="md:row-span-3 bg-black  rounded-2xl w-full h-full text-white drop-shadow-lg">
        <div className="bg-red-600 p-1 w-28 rounded-full text-sm text-white font-bold flex justify-evenly m-3 md:m-3">
          ⏱️ MISSION
        </div>
        <div className="h-full text-justify p-3 md:p-4  text-xl md:text-2xl lg:text-3xl">
          <h1>
            To enhancing the growth of new learner with creative
            Design and Development to deliver market-defining high-quality
            solutions that create value and consistent competitive advantage for
            newbies around the world.
          </h1>
        </div>
      </div>
    </>
  );
}

export default Mission;
